import { computed, makeObservable } from 'mobx'
import RootStore from 'mobx-stores/root-store'
import { ProductsTableBase, TriggerSearchFunc } from 'mobx-stores/utils'

export class StoreProductsTableStore extends ProductsTableBase {
  private rootStore: typeof RootStore

  constructor (rootStore: any) {
    super()
    this.rootStore = rootStore
    makeObservable(this, {
      storeId: computed
    })
  }

  // METHODS
  public clearStore = (): void => {
    this.clearPaginationSearchBaseStore()
  }

  public triggerSearch: TriggerSearchFunc = async (options): Promise<void> => {
    if (!this.storeId) return
    const data = await this.rootStore.generalStore.api.storeApi.getAllProductsFiltered(
      this.storeId,
      this.productFilter,
      { pageQueryParams: this.getPageQueryParams(options?.resetPageNumber) }
    )
    this.handleSearchResult(data)
  }

  // COMPUTED
  public get storeId (): number {
    return this.rootStore.viewStorePageStore.store?.id || null
  }

  /** Handle sync products */
  public handleSyncProducts = async ():Promise<void> => {
    /** Sync Products from Shopify */
   await this.rootStore.generalStore.api.productApi.getProductsFromShopify(this.rootStore.viewStorePageStore.store?.id)

  await this.rootStore.generalStore.api.storeApi.generateAllTags(this.rootStore.viewStorePageStore.store?.id)

   /** Refresh the store products */
   const data =
     await this.rootStore.generalStore.api.storeApi.getAllProductsFiltered(
       this.storeId,
       this.productFilter
     );
    
  /** Store the products */
   this.handleSearchResult(data);
  }
}
